<template>
  <v-dialog scrollable v-model="dialog" max-width="500px">
    <v-card
      style="border-radius:20px;"
      class="py-2 strategio-card-container"
    >
      <!-- <v-container class="py-0"> -->
      <v-card-title
        class="py-2 justify-center"
        style="font-size:20px;font-weight:500;"
      >{{isNew ? 'Crear carpeta' : 'Editar carpeta'}} {{heritable ? 'base' : ''}}</v-card-title>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-text>
        <v-select
          v-if="heritable"
          clearable
          v-model="heritableSelected"
          item-text="itemName"
          item-value="itemID"
          :items="heritableFolders"
          :label="isNew ? 'Seleccione estructura' : 'Vincular a estructura'"
        ></v-select>
        <v-text-field
          name="newFolderName"
          label="Nuevo nombre de la carpeta"
          id="newFolderName"
          v-model="folderName"
          clearable
        ></v-text-field>
        <!-- color="primary" -->
        <v-checkbox
          style="color:#01C0D1 !important;"
          label="Entrar a la carpeta"
          v-model="enterInFolder"
        ></v-checkbox>
        <!-- color="primary" -->
        <v-checkbox
          style="color:#01C0D1 !important;"
          label="Heredable"
          v-model="toBeHeritableFinal"
          :disabled="!!heritable || !!heritableSelected"
          v-if="isNew && ($route.params.folderID == 0 || String($route.params.folderID).startsWith('H'))"
        ></v-checkbox>
      </v-card-text>
      <div class="divisor">
        <v-divider></v-divider>
      </div>
      <v-card-actions>
        <v-btn
          small depressed rounded
          class="strategio-dialog-button"
          color="grey lighten-3"
          :disabled="isLoadingOK"
          v-if="true"
          @click.native="replicateFolder"
        >Crear estructura</v-btn>
        <v-spacer></v-spacer>
        <v-btn
          small dark depressed rounded
          class="strategio-dialog-button"
          color="error"
          @click.native="dialog = false"
        >Cerrar</v-btn>
        <v-btn
          small dark depressed rounded
          class="strategio-dialog-button"
          color="success"
          :loading="isLoadingOK"
          @click.native="sendNewData()"
        >Aceptar</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import {filter} from 'lodash'

import eventBus from '../../utils/eventBus'

import reportsStorage from '../../storage/reportsStorage'
import structureStorage from '../../storage/structureStorage'

export default {
  name: 'folder-form-dialog',
  data () {
    return {
      dialog: false,
      // dialog: true,
      folderID: '',
      folderName: '',
      parentName: '',
      containedBy: '',
      structureID: '',
      isNew: false,
      // isNew: true,
      enterInFolder: false,
      heritable: false,
      toBeHeritable: false,

      inherited: 0,
      structureItemInheritance: false,

      heritableFolders: [],
      heritableSelected: '',

      isLoadingOK: false
      // isLoadingReplication: false
    }
  },
  computed: {
    toBeHeritableFinal: {
      set (newVal) {
        this.toBeHeritable = newVal
      },
      get () {
        return (!!this.heritable || this.toBeHeritable) && !this.heritableSelected
      }
    }
  },
  methods: {
    hasStructureItemInheritance () {
      // console.log('???', 'containedBy', this.containedBy)
      // console.log('???', `containedBy.startsWith('HI')`, this.containedBy.startsWith('HI'))
      return this.containedBy.startsWith('HI')
    },
    sendNewData () {
      this.isLoadingOK = true
      if (this.isNew) {
        if (this.toBeHeritableFinal) {
          // Preguntar si estoy en root o no
          // eslint-disable-next-line
          if (this.containedBy == 0) {
            // alert('hmm')
            structureStorage.createHeritableStructure({
              data: {
                folderName: this.folderName
              },
              onSuccess: () => {
                eventBus.$emit('open-custom-snack-bar', {message: 'Estructura heredable creada exitosamente', itsOk: true})

                eventBus.$emit('reload-items')
                this.dialog = false
                this.isLoadingOK = false
              },
              onError: (error) => {
                console.warn('Error creando estructura heredable: ', error)
                eventBus.$emit('open-custom-snack-bar', {message: 'Error creando estructura heredable', itsOk: false})
                this.isLoadingOK = false
              }
            })
          } else {
            // CHEQUEAR, NO DEBE HACER HEREDABLES
            //  A LAS CARPETAS HIJAS
            structureStorage.createHeritableItem({
              data: {
                structureID: this.structureID,
                itemName: this.folderName,
                description: '',
                labels: '',
                isFolder: true,
                containedBy: this.containedBy,
                structureItemInheritance: this.hasStructureItemInheritance()
              },
              onSuccess: (result) => {
                eventBus.$emit('open-custom-snack-bar', {message: 'Folder heredable creado exitosamente', itsOk: true})

                eventBus.$emit('reload-items')
                this.dialog = false
                this.isLoadingOK = false
              },
              onError: (error) => {
                console.warn('Error creando folder heredable: ', error)
                eventBus.$emit('open-custom-snack-bar', {message: 'Error creando folder heredable', itsOk: false})
                this.isLoadingOK = false
              }
            })
          }
        } else {
          // Se podría usar esa variable en algún momento, u otro caso
          // eslint-disable-next-line
          let [structureItemInheritanceFlag, structureID] = (/^(HI?)(\d+)$/.exec(this.heritableSelected) && /^(HI?)(\d+)$/.exec(this.heritableSelected).slice(1)) || [false, 0]
          if (this.heritableSelected) { // Si he seleccionado alguna estr.
            /* // console.log({
              structureID: 'hmm:' + structureID,
              folderName: 'hmm:' + this.folderName,
              containedBy: 'hmm:' + this.containedBy
            }) */
            structureStorage.replicateStructure({
              data: {
                structureID: structureID,
                folderName: this.folderName,
                containedBy: this.containedBy
              },
              onSuccess: (result) => {
                eventBus.$emit('open-custom-snack-bar', {message: 'Estructura replicada exitosamente', itsOk: true})

                eventBus.$emit('reload-items')
                this.dialog = false
                this.isLoadingOK = false
              },
              onError: (error) => {
                console.warn('Error replicando estructura: ', error)
                eventBus.$emit('open-custom-snack-bar', {message: 'Error replicando estructura', itsOk: false})
                this.isLoadingOK = false
              }
            })
          } else {
            // Con esto creo un folder que esta vinculado a una estructura
            //  pero que no lo replica, el cual es el propósito de esto.
            reportsStorage.addItem({
              data: {
                itemName: this.folderName,
                containedBy: this.containedBy,
                isFolder: true,
                // Se pueden enviar por defecto ya que
                //  no hay otra forma en este caso,
                //  si es sin heredar se pueden quitar
                /* inherited: inherited,
                structureItemInheritance: structureItemInheritance */
                inherited: 0,
                structureItemInheritance: false
              },
              onSuccess: (response) => {
                // console.log('this.enterInFolder', this.enterInFolder)
                if (this.enterInFolder) {
                  // console.log('Routing in')
                  this.$router.push(`/${response.data.item.itemID}`)
                } else {
                  // console.log('No routing')
                  // emit to routes/main-page.vue
                  eventBus.$emit('reload-items')
                }
                this.dialog = false
                this.isLoadingOK = false
              },
              onError: (error) => {
                console.warn('No pudo crearse carpeta', error)
                eventBus.$emit('open-custom-snack-bar', {message: 'No se ha podido crear la carpeta', itsOk: false})
                this.isLoadingOK = false
              }
            })
          }
        }
      } else {
        if (this.toBeHeritableFinal) {
          structureStorage.updateHeritableItem({
            data: {
              containedBy: this.containedBy,
              structureID: this.structureID,
              isFolder: true,
              itemID: this.folderID,
              itemName: this.folderName,
              description: '',
              labels: '',
              imageUrl: '',
              removed: false
            },
            onSuccess: () => {
              this.enterInFolder && this.$router.push(`/${this.folderID}`)
              eventBus.$emit('open-custom-snack-bar', {message: 'Se ha actualizado el reporte heredable correctamente', itsOk: true})
              // emit to routes/main-page.vue
              eventBus.$emit('reload-items')
              this.dialog = false
              this.isLoadingOK = false
            },
            onError: (error) => {
              console.warn('Error updating a heritable report: ', error)
              eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema actualizando el reporte heredable', itsOk: false})
              this.isLoadingOK = false
            }
          })
        } else {
          let [structureItemInheritance, inherited] = (/^(HI?)(\d+)$/.exec(this.heritableSelected) && /^(HI?)(\d+)$/.exec(this.heritableSelected).slice(1)) || [false, 0]
          const wasPossible = reportsStorage.editItem(
            {itemID: this.folderID},
            {
              itemName: this.folderName,
              isFolder: true,
              // inherited: inherited,
              // structureItemInheritance: structureItemInheritance
              inherited: inherited,
              structureItemInheritance: structureItemInheritance && structureItemInheritance.startsWith('HI')
            },
            {
              onSuccess: () => {
                eventBus.$emit('open-custom-snack-bar', {message: 'Se ha actualizado el folder', itsOk: true})
                // emit to routes/main-page.vue
                eventBus.$emit('reload-items', {})
                this.dialog = false
                this.isLoadingOK = false
              },
              onError: (error) => {
                console.warn('Error updating normal folder: ', error)
                eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema actualizando el folder', itsOk: false})
                this.isLoadingOK = false
              }
            }
          )

          if (wasPossible && this.enterInFolder) {
            this.$router.push(`/${this.folderID}`)
          }
        }
      }
    },
    replicateFolder () {
      // emits to: components/dialogs/replicate-folder-dialog
      eventBus.$emit('open-replicate-folder-dialog', {
        itemID: this.folderID,
        originalName: this.folderName,
        onSuccess: () => { this.dialog = false }
      })
      /* this.isLoadingReplication = true
      structureStorage.replicateFolder({
        data: {
          itemID: this.folderID
        },
        onSuccess: () => {
          eventBus.$emit('open-custom-snack-bar', {message: 'Se ha creado el folder base correctamente', itsOk: true})
          // emit to routes/main-page.vue
          eventBus.$emit('reload-items', {})
          this.dialog = false
          this.isLoadingReplication = false
        },
        onError: (error) => {
          console.warn('Error replicating folder: ', error)
          eventBus.$emit('open-custom-snack-bar', {message: 'Ocurrió un problema creando el folder base', itsOk: false})
          this.isLoadingReplication = false
        }
      }) */
    }
  },
  created () {
    eventBus.$off('open-folder-form')
    eventBus.$on('open-folder-form', (item, heritableFolders) => {
      structureStorage.getHeritableItems({
        onSuccess: (heritableFolders) => {
          this.heritableFolders = filter(heritableFolders, (item) => {
            // eslint-disable-next-line
            return item.isFolder === 1 && item.containedBy == 0
          })
        }
      })
      this.toBeHeritable = false

      this.heritable = item.heritable
      this.isNew = !('itemID' in item)
      this.containedBy = item.containedBy
      this.folderID = item.itemID
      this.folderName = item.itemName
      // this.parentName = item.parentName
      this.structureID = item.structureID || item.origin

      this.inherited = item.inherited
      this.structureItemInheritance = item.structureItemInheritance

      this.heritableSelected = this.structureItemInheritance !== undefined ? ((this.structureItemInheritance ? 'HI' : 'H') + this.inherited) : ''

      this.dialog = true
      this.isLoadingOK = false
      // this.isLoadingReplication = false
    })
  }
}
</script>

<style>
.strategio-stardard-cards {
  /* background-color: red !important; */
  border-radius: 20px !important;
  padding: 10px !important;
}

.strategio-stardard-cards>.card__title {
  /* font-size: 30px !important; */
  /* text-align: center !important; */
}

</style>



// WEBPACK FOOTER //
// src/components/dialogs/folder-form-dialog.vue